import { ParseKeys, TFunction } from "i18next";

export interface ProvinceType {
  id: number;
  code: string;
  name: string;
}

/** A province's name in the current language; `code` is e.g. "ON". */
export const provinceLabel = (t: TFunction<"common">, code: string) =>
  t(`provinces.${code}` as ParseKeys<"common">);

export const provinces: ProvinceType[] = [
  { id: 1, code: "ON", name: "Ontario" },
  { id: 2, code: "QC", name: "Quebec" },
  { id: 3, code: "BC", name: "British Columbia" },
  { id: 4, code: "AB", name: "Alberta" },
  { id: 5, code: "MB", name: "Manitoba" },
  { id: 6, code: "SK", name: "Saskatchewan" },
  { id: 7, code: "NS", name: "Nova Scotia" },
  { id: 8, code: "NB", name: "New Brunswick" },
  { id: 9, code: "PE", name: "Prince Edward Island" },
  { id: 10, code: "NL", name: "Newfoundland and Labrador" },
  { id: 11, code: "NT", name: "Northwest Territories" },
  { id: 12, code: "YT", name: "Yukon" },
  { id: 13, code: "NU", name: "Nunavut" },
];
